import type { TranslationCatalog } from "../TranslationManager";

export const tl: TranslationCatalog = {
  "labels.cardNumber": "Numero ng card",
  "labels.expirationDate": "Petsa ng pagkawalang-bisa",
  "labels.cvc": "Security code",
  "placeholders.cardNumber": "1234 1234 1234 1234",
  "placeholders.expirationDate": "BB / TT",
  "placeholders.cvc": "CVV",
  "errors.invalidCardNumber": "Hindi wasto ang numero ng iyong card.",
  "errors.invalidExpiryDate": "Hindi wasto ang petsa ng pagkawalang-bisa ng iyong card.",
  "errors.invalidCvc": "Hindi wasto ang security code ng iyong card.",
  "errors.incompleteCardNumber": "Hindi kumpleto ang numero ng iyong card.",
  "errors.incompleteExpiryDate": "Hindi kumpleto ang petsa ng pagkawalang-bisa ng iyong card.",
  "errors.incompleteCvc": "Hindi kumpleto ang security code ng iyong card.",
  "errors.expiredCard": "Nag-expire na ang iyong card.",
  "aria.cardNumber": "Numero ng card",
  "aria.expirationDate": "Petsa ng pagkawalang-bisa",
  "aria.cvc": "Security code",
  "aria.cardInput": "Impormasyon ng card",
};
